(function () {
  var SELECTOR = ".product-badge__bottom-text";
  var MIN_FONT_SIZE_PX = 8;
  var STEP_PX = 0.5;

  function fitOneLine(el) {
    if (!el) return;
    var styles = window.getComputedStyle(el);
    var maxSize = parseFloat(styles.fontSize) || 12;
    var minSize = parseFloat(el.getAttribute("data-min-font-size")) || MIN_FONT_SIZE_PX;
    var fontSize = maxSize;
    var safeGuard = 0;

    el.style.whiteSpace = "nowrap";
    el.style.fontSize = maxSize + "px";

    while (el.scrollWidth > el.clientWidth && fontSize > minSize && safeGuard < 80) {
      fontSize = fontSize - STEP_PX;
      el.style.fontSize = fontSize + "px";
      safeGuard += 1;
    }
  }

  function fitAll(scope) {
    var root = scope || document;
    var badges = root.querySelectorAll(SELECTOR);
    if (!badges.length) return;
    badges.forEach(fitOneLine);
  }

  function debounce(fn, delay) {
    var timer;
    return function () {
      var args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(null, args);
      }, delay);
    };
  }

  document.addEventListener("DOMContentLoaded", function () {
    fitAll(document);
  });

  window.addEventListener(
    "resize",
    debounce(function () {
      fitAll(document);
    }, 150)
  );

  var observer = new MutationObserver(
    debounce(function () {
      fitAll(document);
    }, 100)
  );

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();
